var dotsTypeData = ['primary', 'default'];
export default dotsTypeData;